import { FC, useEffect, useState, useMemo, useCallback, useReducer, memo } from 'react';
import { API, Competition, CompetitionAPI, Endpoints, PageModel, Project, ProjectAPI } from '@brg/api';
import { HintTooltip, Tooltip, useToasts } from '@brg/ui';
import { useProfile } from 'core/auth';
import styled, { useTheme } from 'styled-components';
import { bProfile } from '@brg/auth';
import { IconWrapper } from 'shared/assets/styles';
import { LayoutConst } from 'core/modules/layout.module';
import { STATUSES } from '_competition/const';
import { useTranslation } from 'react-i18next';
import { getCompetitionTitle } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import { MagicBoxRow, OkButton, OkButtonWrapper, Outer, TooltipList } from './toolsStyles';
import { AppTester } from 'supporting';
import { CompetitionIcon } from "../../../icons/projectToolsWithResize/CompetitionIcon";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { useSelector } from 'react-redux';
import { CompetitionProjectsSelector } from 'shared/reducers/CompetitionProjects';

// todo: попробовать заменить на нормальную обработу клика, а не симуляцию
const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
const simulateMouseClick = (element: any) => {
  mouseClickEvents.forEach(mouseEventType =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1
      })
    )
  );
}

export const ToolBarItemWrapperModer = styled.div<{ iconStyles?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 12px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    padding: 0 16px;
    margin: 0;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 0;
    margin: 0 0 0 12px;
  }
`;

export const ProjectCompetitionsWrapper = styled.div<{
  isBottomTooltip?: boolean
}>`
    display: flex;
    margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 24}px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 16}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-bottom: 0px;
    }
`

type PropsT = {
  project?: any;
  onClose?: () => void;
  showLikeIcon?: boolean;
  inActiveState?: boolean;
  isBottomTooltip?: boolean
  tooltipProps?: any;
  //onShouldReload?: (project: Project) => void;
};

const reducer = (state: any, action: any): any => {
  switch (action.type) {
    case 'COMPETITION_TOGGLED':
      const { checked, initialValue } = state[action.payload];
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          checked: !checked,
          changed: initialValue !== !checked,
        }
      };
    case 'VALUES_REINITIALIZED':
      const changedcompetitionIds = action.payload.reduce((result: any, competitionId: any) => {
        const { checked } = state[competitionId];
        return {
          ...result,
          [competitionId]: {
            ...state[competitionId],
            initialValue: checked,
            changed: false,
          }
        }
      }, {})
      return {
        ...state,
        ...changedcompetitionIds,
      };
    case 'VALUES_INITIALIZED':
      return {
        ...action.payload
      };
    default:
      return state;
  }
}

const toggleCompetition = (payload: any) => ({
  type: 'COMPETITION_TOGGLED',
  payload,
})

const reinitializeValues = (payload: string[]) => ({
  type: 'VALUES_REINITIALIZED',
  payload,
})

const initializeValues = (payload: any) => ({
  type: 'VALUES_INITIALIZED',
  payload,
})

const ProjectCompetitions: FC<PropsT> = ({ project, onClose, showLikeIcon, inActiveState, isBottomTooltip, tooltipProps }) => {

  const profile = useProfile();
  const toasts = useToasts();
  const { t, i18n } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const theme = useTheme()
  const onWhiteBg = !isGeo && !isSuperPuper;

  const { projectCompetitions: competitions } = useSelector(CompetitionProjectsSelector)

  const isModer = useMemo(() => profile && bProfile.isModer(profile), [profile]);

  const initialState = useMemo(() => competitions ? competitions.reduce((result, competition) => {
    //@ts-ignore
    const hasCompetition = !!project.competitionApproves?.find?.(({ competitionId }) => competitionId === competition.competitionId);
    return {
      ...result,
      [competition.competitionId]: {
        initialValue: hasCompetition,
        label: getCompetitionTitle(competition),
        checked: hasCompetition,
        changed: false,
      }
    }
  }, {}) : {}, [competitions, project]);

  const [state, dispatch] = useReducer<any>(reducer, {});

  useEffect(() => {
    //@ts-ignore
    dispatch(initializeValues(initialState));
  }, [initialState])

  const [tp, stp] = useState<Project<'Global'>>(project);

  const changedCompetitions = useMemo(() => {
    //@ts-ignore
    return Object.entries(state).reduce((result, [competition, { changed }]) => {
      if (changed) {
        return [...result, competition]
      }
      return result;
    }, []);
  }, [state])

  const isButtonDisabled = !changedCompetitions.length;

  const reloadStp = useCallback(() => {
    if (project) {
      ProjectAPI.Get({ idProject: project.projectId })
        .then((v) => v.json())
        .then(stp);
    }
  }, [project]);

  const handleOk = useCallback(() => {
    const dataCompetitions: any[] = [];

    //@ts-ignore
    Object.entries(state).forEach(([competition, {
      label,
      changed,
      checked,
    }]: [any, any]) => {
      if (changed) {
        dataCompetitions.push({
          competitionId: competition,
          operation: checked ? 1 : 0,
        })
        simulateMouseClick(document.querySelector(".competition-send"))
        toasts.info(checked ? `Проект добавлен на конкурс ${label}` : `Проект убран из конкурса ${label}`);
      }
    })

    if (dataCompetitions.length) {
      API.request()
        .endpoint(Endpoints.competitions)
        .url(`/api/Competition/UpdatePeojectCompetitions`)
        .post()
        .body({
          projectId: project.projectId,
          competitions: dataCompetitions,
        })
        .send()
        .then(() => {
          //@ts-ignore
          dispatch(reinitializeValues(changedCompetitions))
        })
    }
    onClose && onClose();
  }, [
    state,
    toasts,
    onClose
  ]);

  //@ts-ignore
  const checkboxes = Object.entries(state).map(([competition, {
    checked,
    label
  }]: [any, any]) => {
    return (
      <MagicBoxRow
        onClick={() => {
          //@ts-ignore
          dispatch(toggleCompetition(competition))
        }}
        checked={checked}
        label={label}
      />
    )
  })

  if (inActiveState && isModer) {
    return (
      <ProjectCompetitionsWrapper isBottomTooltip={isBottomTooltip}>
        <ToolBarItemWrapperModer className='ps-action-moder-btn competition-send' iconStyles={showLikeIcon}>
          {!showLikeIcon ? (
            t('competitions').toLowerCase()
          ) : (
            <IconWrapper>
              <CompetitionIcon />
            </IconWrapper>
          )}
        </ToolBarItemWrapperModer>
      </ProjectCompetitionsWrapper>
    )
  }

  return (
    <>
      {checkboxes && checkboxes.length > 0 && (
        <ProjectCompetitionsWrapper isBottomTooltip={isBottomTooltip}>
          <Tooltip
            zIndex={99999999999}
            placement='top'
            trigger={"click"}
            target={(
              <ToolBarItemWrapperModer className='ps-action-moder-btn competition-send' iconStyles={showLikeIcon}>
                {!showLikeIcon ? (
                  t('competitions').toLowerCase()
                ) : (
                  <HintTooltip customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.competition")} noDisappearDelay={isBottomTooltip} z={1000} onWhiteBg={onWhiteBg} {...tooltipProps}>
                    <IconWrapper>
                      <CompetitionIcon />
                    </IconWrapper>
                  </HintTooltip>
                )}
              </ToolBarItemWrapperModer>
            )}
          >
            <Outer isGeo={isGeo}>
              <TooltipList>
                {checkboxes}
              </TooltipList>
              <OkButtonWrapper>
                <OkButton isGeo={isGeo} disabled={isButtonDisabled} onClick={handleOk}>Подтвердить</OkButton>
              </OkButtonWrapper>
            </Outer>
          </Tooltip>
        </ProjectCompetitionsWrapper>
      )}
    </>
  );
};

export default memo(ProjectCompetitions);
import { FC, useEffect, useState, useMemo, useCallback, useReducer, memo } from 'react';
import { API, Competition, CompetitionAPI, Endpoints, PageModel, Project, ProjectAPI } from '@brg/api';
import { HintTooltip, Tooltip, useToasts } from '@brg/ui';
import { useProfile } from 'core/auth';
import styled, { useTheme } from 'styled-components';
import { bProfile } from '@brg/auth';
import { IconWrapper } from 'shared/assets/styles';
import { LayoutConst } from 'core/modules/layout.module';
import { STATUSES } from '_competition/const';
import { useTranslation } from 'react-i18next';
import { getCompetitionTitle } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import { MagicBoxRow, OkButton, OkButtonWrapper, Outer, TooltipList } from './toolsStyles';
import { AppTester } from 'supporting';
import { CompetitionIcon } from "../../../icons/projectToolsWithResize/CompetitionIcon";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { useSelector } from 'react-redux';
import { CompetitionProjectsSelector } from 'shared/reducers/CompetitionProjects';

// todo: попробовать заменить на нормальную обработу клика, а не симуляцию
const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
const simulateMouseClick = (element: any) => {
  mouseClickEvents.forEach(mouseEventType =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1
      })
    )
  );
}

export const ToolBarItemWrapperModer = styled.div<{ iconStyles?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 12px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    padding: 0 16px;
    margin: 0;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 0;
    margin: 0 0 0 12px;
  }
`;

export const ProjectCompetitionsWrapper = styled.div<{
  isBottomTooltip?: boolean
}>`
    display: flex;
    margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 24}px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 16}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-bottom: 0px;
    }
`

type PropsT = {
  project?: any;
  onClose?: () => void;
  showLikeIcon?: boolean;
  inActiveState?: boolean;
  isBottomTooltip?: boolean
  tooltipProps?: any;
  //onShouldReload?: (project: Project) => void;
};

const reducer = (state: any, action: any): any => {
  switch (action.type) {
    case 'COMPETITION_TOGGLED':
      const { checked, initialValue } = state[action.payload];
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          checked: !checked,
          changed: initialValue !== !checked,
        }
      };
    case 'VALUES_REINITIALIZED':
      const changedcompetitionIds = action.payload.reduce((result: any, competitionId: any) => {
        const { checked } = state[competitionId];
        return {
          ...result,
          [competitionId]: {
            ...state[competitionId],
            initialValue: checked,
            changed: false,
          }
        }
      }, {})
      return {
        ...state,
        ...changedcompetitionIds,
      };
    case 'VALUES_INITIALIZED':
      return {
        ...action.payload
      };
    default:
      return state;
  }
}

const toggleCompetition = (payload: any) => ({
  type: 'COMPETITION_TOGGLED',
  payload,
})

const reinitializeValues = (payload: string[]) => ({
  type: 'VALUES_REINITIALIZED',
  payload,
})

const initializeValues = (payload: any) => ({
  type: 'VALUES_INITIALIZED',
  payload,
})

const ProjectCompetitions: FC<PropsT> = ({ project, onClose, showLikeIcon, inActiveState, isBottomTooltip, tooltipProps }) => {

  const profile = useProfile();
  const toasts = useToasts();
  const { t, i18n } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const theme = useTheme()
  const onWhiteBg = !isGeo && !isSuperPuper;

  const { projectCompetitions: competitions } = useSelector(CompetitionProjectsSelector)

  const isModer = useMemo(() => profile && bProfile.isModer(profile), [profile]);

  const initialState = useMemo(() => competitions ? competitions.reduce((result, competition) => {
    //@ts-ignore
    const hasCompetition = !!project.competitionApproves?.find?.(({ competitionId }) => competitionId === competition.competitionId);
    return {
      ...result,
      [competition.competitionId]: {
        initialValue: hasCompetition,
        label: getCompetitionTitle(competition),
        checked: hasCompetition,
        changed: false,
      }
    }
  }, {}) : {}, [competitions, project]);

  const [state, dispatch] = useReducer<any>(reducer, {});

  useEffect(() => {
    //@ts-ignore
    dispatch(initializeValues(initialState));
  }, [initialState])

  const [tp, stp] = useState<Project<'Global'>>(project);

  const changedCompetitions = useMemo(() => {
    //@ts-ignore
    return Object.entries(state).reduce((result, [competition, { changed }]) => {
      if (changed) {
        return [...result, competition]
      }
      return result;
    }, []);
  }, [state])

  const isButtonDisabled = !changedCompetitions.length;

  const reloadStp = useCallback(() => {
    if (project) {
      ProjectAPI.Get({ idProject: project.projectId })
        .then((v) => v.json())
        .then(stp);
    }
  }, [project]);

  const handleOk = useCallback(() => {
    const dataCompetitions: any[] = [];

    //@ts-ignore
    Object.entries(state).forEach(([competition, {
      label,
      changed,
      checked,
    }]: [any, any]) => {
      if (changed) {
        dataCompetitions.push({
          competitionId: competition,
          operation: checked ? 1 : 0,
        })
        simulateMouseClick(document.querySelector(".competition-send"))
        toasts.info(checked ? `Проект добавлен на конкурс ${label}` : `Проект убран из конкурса ${label}`);
      }
    })

    if (dataCompetitions.length) {
      API.request()
        .endpoint(Endpoints.competitions)
        .url(`/api/Competition/UpdatePeojectCompetitions`)
        .post()
        .body({
          projectId: project.projectId,
          competitions: dataCompetitions,
        })
        .send()
        .then(() => {
          //@ts-ignore
          dispatch(reinitializeValues(changedCompetitions))
        })
    }
    onClose && onClose();
  }, [
    state,
    toasts,
    onClose
  ]);

  //@ts-ignore
  const checkboxes = Object.entries(state).map(([competition, {
    checked,
    label
  }]: [any, any]) => {
    return (
      <MagicBoxRow
        onClick={() => {
          //@ts-ignore
          dispatch(toggleCompetition(competition))
        }}
        checked={checked}
        label={label}
      />
    )
  })

  if (inActiveState && isModer) {
    return (
      <ProjectCompetitionsWrapper isBottomTooltip={isBottomTooltip}>
        <ToolBarItemWrapperModer className='ps-action-moder-btn competition-send' iconStyles={showLikeIcon}>
          {!showLikeIcon ? (
            t('competitions').toLowerCase()
          ) : (
            <IconWrapper>
              <CompetitionIcon />
            </IconWrapper>
          )}
        </ToolBarItemWrapperModer>
      </ProjectCompetitionsWrapper>
    )
  }

  return (
    <>
      {checkboxes && checkboxes.length > 0 && (
        <ProjectCompetitionsWrapper isBottomTooltip={isBottomTooltip}>
          <Tooltip
            zIndex={99999999999}
            placement='top'
            trigger={"click"}
            target={(
              <ToolBarItemWrapperModer className='ps-action-moder-btn competition-send' iconStyles={showLikeIcon}>
                {!showLikeIcon ? (
                  t('competitions').toLowerCase()
                ) : (
                  <HintTooltip customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.competition")} noDisappearDelay={isBottomTooltip} z={1000} onWhiteBg={onWhiteBg} {...tooltipProps}>
                    <IconWrapper>
                      <CompetitionIcon />
                    </IconWrapper>
                  </HintTooltip>
                )}
              </ToolBarItemWrapperModer>
            )}
          >
            <Outer isGeo={isGeo}>
              <TooltipList>
                {checkboxes}
              </TooltipList>
              <OkButtonWrapper>
                <OkButton isGeo={isGeo} disabled={isButtonDisabled} onClick={handleOk}>Подтвердить</OkButton>
              </OkButtonWrapper>
            </Outer>
          </Tooltip>
        </ProjectCompetitionsWrapper>
      )}
    </>
  );
};

export default memo(ProjectCompetitions);
